import { PickPartial } from '@bpd-library/types';

export const nextEvent = <T extends Event | CustomEvent>(
    eventTarget: PickPartial<EventTarget, 'addEventListener' | 'removeEventListener'>,
    eventName: string,
    ...raceEvents: string[]
): Promise<T> => {
    if (!raceEvents.length) {
        return new Promise<T>((res) => {
            const callback = (event: T) => {
                eventTarget.removeEventListener(eventName, callback);
                res(event);
            };

            eventTarget.addEventListener(eventName, callback);
        });
    }

    const controller = new AbortController();
    const { signal } = controller;

    return Promise.race(
        [eventName, ...raceEvents].map((name) => {
            return new Promise<T>((res) => {
                const callback = (event: T) => {
                    controller.abort();
                    res(event);
                };

                eventTarget.addEventListener(name, callback, { signal });
            });
        }),
    );
};
